module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "message"
  }, [_vm._v("\n      Please use the menu at the top of the page to continue browsing\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_c('ImageLoader', {
    staticClass: "image",
    attrs: {
      "src": _vm.randomImage,
      "lazy": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("\n      A delicious creation that has finished baking\n    ")])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "wrapper not-found__blog-post-container"
  }, [_c('div', {
    staticClass: "not-found__while-you-wait-title"
  }, [_vm._v("While you wait, have a read of my latest blog post")]), _vm._v(" "), _c('div', {
    staticClass: "not-found__blog-post"
  }, [_vm._v("\n      Either embed the latest blog post here, or just show the excerpt, and the user can then click on Read More, to\n      be taken through to the blog posts page\n    ")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('p', [_vm._v("Or use the menu at the top to navigate to a page that is ready")]), _vm._v(" "), _c('ul', {
    staticClass: "not-found__menu"
  }, [_vm._l((_vm.$store.state.routerLinks), function(link, index) {
    return [_c('li', {
      staticClass: "nav-link"
    }, [_c('router-link', {
      attrs: {
        "to": link.path,
        "exact": ""
      }
    }, [_vm._v(_vm._s(link.label))])], 1)]
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Oops, this page hasn't been baked yet!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9eb4a904"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NotFound.vue
// module id = 100
// module chunks = 4